import options from '../../../../config/options.json'
import consoleLogger from '../../../../modules/console-logger'

const hasRequiredFields = (userData) => {
  const [consoleLog] = consoleLogger('HasRequiredCustomFields')
  if (userData === {}) {
    return false
  }

  const requiredFields = options.User.requiredUserData

  const hasRequiredCustomFields = requiredFields.every((requiredField) => {
    consoleLog('required field', requiredField, 'UserData')
    if (requiredField === 'first_name') {
      const isSetFirstName = userData.first_name !== ''
      consoleLog('has required field', isSetFirstName, 'UserData')
      return isSetFirstName
    }

    if (requiredField === 'last_name') {
      const isSetLastName = userData.last_name !== ''
      consoleLog('has required field', isSetLastName, 'UserData')
      return isSetLastName
    }

    const hasRequiredFieldData = userData.custom_field_values.some(
      (obj) => obj.field_name === requiredField && obj.value !== '',
    )
    consoleLog('has required field', hasRequiredFieldData, 'UserData')

    return !!hasRequiredFieldData
  })

  consoleLog('has ALL required fields', hasRequiredCustomFields, 'UserData')

  return hasRequiredCustomFields
}

export default hasRequiredFields
